/**
 * Privacy-preserving pageview tracker for The CCS Approach.
 * - Mints an anonymous session UUID stored in localStorage (never linked to identity)
 * - Sends a single pageview per (session, path) tuple per page-view event
 * - Fires only on public paths; admin paths (/app/*) are ignored server-side too
 * - Uses navigator.sendBeacon when available for reliability on tab-close
 */
import axios from "axios";

const STORAGE_KEY = "ccs_session_id";
const API_BASE = process.env.REACT_APP_BACKEND_URL;

function getSessionId() {
  try {
    let sid = localStorage.getItem(STORAGE_KEY);
    if (!sid) {
      sid = (crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2) + Date.now())
        .replace(/-/g, "")
        .slice(0, 32);
      localStorage.setItem(STORAGE_KEY, sid);
    }
    return sid;
  } catch {
    // If localStorage blocked (Safari private mode), fall back to a per-tab UUID.
    return "tab-" + String(Math.random()).slice(2, 14);
  }
}

const SKIP_PREFIXES = ["/app", "/login", "/signup"];

export function trackPageview(path) {
  const clean = (path || window.location.pathname || "/").split("?")[0];
  if (SKIP_PREFIXES.some((p) => clean === p || clean.startsWith(p + "/"))) return;

  const body = {
    session_id: getSessionId(),
    path: clean,
    referrer: (typeof document !== "undefined" ? document.referrer : "").slice(0, 300),
  };

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
      navigator.sendBeacon(`${API_BASE}/api/public/track-pageview`, blob);
      return;
    }
    axios.post(`${API_BASE}/api/public/track-pageview`, body).catch(() => {});
  } catch {
    /* never break rendering because of analytics */
  }
}
